import pixi.plugins.app.Application;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.core.display.Container;
import js.Browser;
import stocking.Scene;
import stocking.SceneManager;
import ld.scenes.EditorScene;
import ld.scenes.GameScene;
import ld.scenes.MenuScene;
import ld.scenes.GameScene;

class Main extends Application 
{

	public function new() 
	{
		super();

		autoResize = false;

		width = 320;
		height = 224;

		backgroundColor = 0x000000;

		antialias = false;
		onUpdate = _animate;
		roundPixels = true;

		var canvas = Browser.document.createCanvasElement();
		Browser.document.body.appendChild(canvas);

		super.start(null, null, canvas);

		var sceneContainer = new Container();
		stage.addChild(sceneContainer);

		SceneManager.instance.transitionToScene( new MenuScene( renderer, stage ) );

		
	}

	function _animate(e:Float) 
	{
		SceneManager.instance.tick(e);
	}

	static function main() 
	{
		new Main();
	}
}